export const manageAccessMixin = {
  computed: {
    authenticated() {
      const keycloak = this.$store.state.keycloak
      return keycloak && keycloak.authenticated
    }
  },
  methods: {
    hasOptionAccess(options, optionName) {
      const hasOptions = options && options.length > 0

      if (!hasOptions) return false

      const option = options.find(o => {
        if (o.name === optionName) return o
      })

      if (!option) return false
      else return option.value
    }
  }
}
